<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"> </app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Formas de pagamento</h1>
        <p class="welcome-message">
          <button mat-icon-button routerLink="/configuracoes/financas">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Configure suas formas de pagamento.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <!-- Skeleton loading -->
        @if (isLoading) {
          <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
          <table mat-table [dataSource]="dataSource">
            <!-- Descrição Column -->
            <ng-container matColumnDef="descricao">
              <th mat-header-cell *matHeaderCellDef>Descrição</th>
              <td mat-cell *matCellDef="let element">
                <div class="descricao-flex">
                  <mat-icon class="material-symbols-outlined">{{ element.googleIconClass }}</mat-icon>
                  <span>{{ element.descricao }}</span>
                </div>
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element">
                <span
                  class="status-badge"
                  [ngClass]="{ 'badge-verde': element.isAtivo, 'badge-vermelho': !element.isAtivo }">
                  {{ element.isAtivo ? 'Ativo' : 'Inativo' }}
                </span>
              </td>
            </ng-container>

            <!-- Ações Column -->
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef class="text-end">Ações</th>
              <td mat-cell *matCellDef="let element" class="text-end">
                <!-- Row loading spinner -->
                @if (loadingItemId === element.idFormaPagamento) {
                  <mat-spinner diameter="24" class="row-spinner"></mat-spinner>
                } @else {
                  <div class="action-buttons">
                    <!-- Favoritar -->
                    @if (element.isAtivo) {
                      <button mat-icon-button matTooltip="Tornar favorito" (click)="favoritar(element)">
                        @if (!element.isFavorito) {
                          <mat-icon class="material-icons-outlined star-action-icon">star_border</mat-icon>
                        } @else {
                          <mat-icon class="material-icons-outlined star-action-icon">star</mat-icon>
                        }
                      </button>
                    }
                    <!-- Habilitar -->
                    @if (!element.isAtivo) {
                      <button mat-icon-button matTooltip="Habilitar" (click)="habilitar(element)">
                        <mat-icon class="material-icons-outlined icon-habilitar">unpublished</mat-icon>
                      </button>
                    }

                    <!-- Desabilitar -->
                    <div
                      [matTooltip]="
                        element.isFavorito
                          ? 'Não é possível desabilitar a forma de pagamento favorita'
                          : 'Desabilitar'
                      ">
                      @if (element.isAtivo) {
                        <button
                          mat-icon-button
                          [disabled]="element.isFavorito"
                          (click)="desabilitar(element)">
                          <mat-icon class="material-icons-outlined icon-desabilitar">check_circle</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="row-custom"
              [class.row-loading]="loadingItemId === row.idFormaPagamento"></tr>
          </table>
        }
      </div>
    </div>
  </div>
</div>
